export default __webpack_public_path__ + "static/media/tileSelect.c46318ea.mp3";